<template>
    <link-dialog v-model="show"
                 confirm-button
                 cancel-button
                 height="486px"
                 width="682px"
                 title="表格设置"
                 initialized
                 dialog-class="link-auto-table-setting-modal"
                 @confirm="p_confirm"
                 @cancel="show = false"
                 disabledHideOnConfirm
                 :loading="loading">
        <link-form class="link-auto-table-setting-modal-form">
            <link-form-column width="50%">
                <link-form-item label="表格显示标题" class="link-auto-table-setting-modal-form-item-left">
                    <link-input v-model="tableConfig.title"/>
                </link-form-item>
                <link-form-item label="默认排序字段">
                    <link-select
                            v-model="tableConfig.sortField"
                            :data="sortData"
                            val-key="field"
                            label-key="title"/>
                </link-form-item>
            </link-form-column>
            <link-form-column width="50%">
                <link-form-item label="默认排序方式" class="link-auto-table-setting-modal-form-item-left">
                    <link-select
                            v-model="tableConfig.sortDesc"
                            :data="sortWay"
                            val-key="val"
                            label-key="name"/>
                </link-form-item>
                <link-form-item label="默认搜索字段">
                    <link-select
                            v-model="tableConfig.searchField"
                            :data="data"
                            val-key="field"
                            label-key="title"/>
                </link-form-item>
            </link-form-column>
        </link-form>
        <div class="link-auto-table-setting-modal-table-wrapper">
            <div class="link-auto-table-setting-modal-table-button-wrapper">
                <link-button label="上移" @click="p_move()"/>
                <link-button label="下移" @click="p_move(false)"/>
            </div>
            <link-table :row-num="8" :data="data" ref="table" defaultEnableEditable :selectIndex.sync="selectIndex">
                <link-table-column-index/>
                <!--                <link-table-column title="顺序" field="order" :width="70" :sort="false" align="center"/>-->
                <link-table-column-input title="列标题" field="title" :width="180" :sort="false" :fit="1"/>
                <link-table-column-input-number title="列宽(像素)" field="width" :width="100" :sort="false"/>
                <link-table-column-checkbox title="自动填充" field="fit" :trueValue="1" :falseValue="0"/>
                <link-table-column-checkbox title="列冻结" field="fixed" trueValue="left" :falseValue="null"/>
                <link-table-column-checkbox title="是否隐藏" field="hide" :trueValue="true" :falseValue="false"/>
            </link-table>
        </div>
        <link-button label="重置" slot="footLeft" @click="p_resetConfig"/>
    </link-dialog>
</template>

<script>
    export default {
        name: "link-auto-table-setting-modal",
        data() {
            return {
                selectIndex: null,
                onConfirm: null,
                data: [],
                show: false,
                autoTable: null,
                loading: false,

                tableConfig: {
                    tableId: null,
                    path: null,
                    title: null,
                    sortField: null,
                    sortDesc: null,
                    searchField: null,
                    columns: [],
                },
                sortWay: [
                    {val: false, name: '升序'},
                    {val: true, name: '降序'},
                ],
                fixedOptions: [
                    {name: '左', val: 'left'},
                    {name: '右', val: 'right'},
                    {name: '无', val: 'center'},
                ],
            }
        },
        computed: {
            sortData() {
                if (!this.tableConfig || !this.tableConfig.columns) return []
				let allColumns = [{field: 'created', title: '创建时间'}, {field: 'lastUpdated', title: '更新时间'}].concat(this.tableConfig.columns)
				/*根据列表字段去重 过滤重复的字段*/
				let newobj = {};
				allColumns = allColumns.reduce((columns, currentValue) => {
					newobj[currentValue.field] ? '' : newobj[currentValue.field] = columns.push(currentValue)
					return columns
				}, [])
                return allColumns;
            },
        },
        methods: {
            async pick(autoTable) {
                return new Promise((rs) => {
                    this.autoTable = autoTable

                    const tableConfig = this.$lv.$tableSetting.getTableConfig(autoTable.option, autoTable.$refs.baseTable.originalColumns)

                    if (!tableConfig) {
                        const message = '无法生成表格配置信息，请联系管理员'
                        this.$dialog.show(message)
                        return Promise.reject(message)
                    }
                    if (!tableConfig.tableId && !tableConfig.path) {
                        const message = '没有设置tableId，请联系管理员'
                        this.$dialog.show(message)
                        return Promise.reject(message)
                    }

                    this.onConfirm = rs
                    Object.assign(this.tableConfig, tableConfig)
                    const data = []
                    this.p_colIterate(tableConfig.columns, (col, group, cols) => {
                        if (!group && !col.disabledConfig) data.push(col)
                    })
                    this.$lv.$utils.insertSort(data, (a, b) => {
                        const ao = a.order || 0
                        const bo = b.order || 0
                        return ao < bo
                    })
                    const len = data.length
                    data.forEach((item, index) => item.order = len - index)
                    this.data = data
                    this.p_reset()
                    this.show = true
                })
            },
            async p_confirm() {
                this.loading = true
                const editData = this.$refs.table.getEdit()
                this.tableConfig.columns = editData.map(({editRow}) => {
                    editRow.width = editRow.width - 0
                    editRow.fit = editRow.fit - 0
                    return editRow
                })
                try {
                    await this.$lv.$tableSetting.saveTableConfig(this.tableConfig)
                    !!this.onConfirm && this.onConfirm()
                    this.show = false
                } catch (e) {
                    console.error(e)
                    this.$dialog.show('保存失败')
                } finally {
                    this.loading = false
                }
            },
            async p_move(up = true) {
                this.scrollTop = this.$refs.table.$refs.body.p_scrollTop || 0
                const editData = this.$refs.table.getEdit()
                editData.forEach(item => item.newRow = item.editRow)
                this.$refs.table.saveEdit(editData)
                let index = this.selectIndex

                if (up) index = await this.p_moveUp(index)
                else index = await this.p_moveDown(index)
                if (index == null) return

                this.$lv.$utils.insertSort(this.data, (a, b) => a.order < b.order)
                this.data = this.$lv.$utils.deepCopy(this.data)
                this.selectIndex = null
                await this.$lv.nextTick()
                this.selectIndex = index
                this.$refs.table.$refs.body.scrollTop(this.scrollTop)
            },
            async p_moveUp(index) {
                if (index === 0) return null
                this.data[index].order++
                this.data[index - 1].order--
                return index - 1
            },
            async p_moveDown(index) {
                if (index === this.data.length - 1) return null
                this.data[index].order--
                this.data[index + 1].order++
                return index + 1
            },
            async p_reset() {
                const len = this.data.length
                this.$lv.$utils.insertSort(this.data, (a, b) => a.order < b.order)
                this.data.forEach((item, index) => item.order = len - index)
                this.data = this.$lv.$utils.deepCopy(this.data)
                this.selectIndex = null
                await this.$lv.nextTick()
                this.selectIndex = 0
            },

            async p_resetConfig() {
                this.loading = true
                await this.$http.post('action/userConfig/deleteTableConfig', {
                    ...this.tableConfig,
                    linkRequestId: null,
                })
                delete this.$userConfig.getUserConfig().tableConfigs[this.tableConfig.id]
                this.$userConfig.saveUserConfig()

                this.autoTable.option.title = this.autoTable.option._initOption.title
                this.autoTable.option.searchField = this.autoTable.option._initOption.searchField
                this.autoTable.option.sortField = this.autoTable.option._initOption.sortField || 'created'
                this.autoTable.option.sortDesc = this.autoTable.option._initOption.sortDesc

                !!this.onConfirm && this.onConfirm()
                this.show = false
                this.loading = false
            },

            p_colIterate(columns, fn) {
                if (!columns || columns.length === 0) return
                else {
                    for (let i = 0; i < columns.length; i++) {
                        const col = columns[i];
                        const handleRet = fn(col, !!col.group, columns)
                        i -= (handleRet != null && this.$lv.$utils.typeOf(handleRet) === 'number' ? handleRet : 0)
                        if (!!col.group) this.p_colIterate(col.children, fn)
                    }
                }
            },
        }
    }
</script>

<style lang="scss">
    .link-auto-table-setting-modal {
        .link-auto-table-setting-modal-form {
            width: 100%;

            .link-form-content {
                width: 100%;

                .link-form-column {
                    margin-right: 0 !important;
                }
            }

            .link-form-column:first-child {
                .link-form-item-label {
                    text-align: left;
                }
            }

            .link-form-column:last-child {
                .link-form-item-content {
                    justify-content: flex-end;
                }
            }
        }

        .link-auto-table-setting-modal-table-wrapper {
            .link-auto-table-setting-modal-table-button-wrapper {
                text-align: right;
                margin-bottom: 16px;
            }
        }
    }

</style>
